import { ExcelColumnNames } from "../constants/columns.constants"
import { replaceCharsAndSpaces } from "./string.helper"

const validateJson = (jsonObj, distributor) => {
    if (typeof jsonObj === 'undefined' || distributor.length === 0)
        return { hasError: true, errorType: 'invalid input' }

    let keysValid = false
    const jsonKeys = Object.keys(Object.assign({}, ...jsonObj))
    const requiredKeys = ExcelColumnNames[distributor.toLowerCase()]
    
    /** Checking columns names*/
    if ( !Array.isArray(jsonKeys) && !Array.isArray(requiredKeys))
        return { hasError: true, errorType: 'not array' }
    
    if (jsonKeys.length !== requiredKeys.length)
        return { hasError: true, errorType: 'column length' }
    
    keysValid = jsonKeys.every((value, index) => {
        if (replaceCharsAndSpaces(value).toLowerCase() === replaceCharsAndSpaces(requiredKeys[index]).toLowerCase())
            return true
    })

    if (!keysValid) {
        return {hasError: true, errorType: 'inequal column' }
    }
    else {
        return {hasError: false , errorType: '' }
    }
    
}

export default validateJson